export default function PostSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-4 animate-pulse">
      {/* User info skeleton */}
      <div className="flex items-center mb-3">
        <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
        <div className="ml-3 flex-1">
          <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
        <div className="w-6 h-6 bg-gray-200 rounded"></div>
      </div>

      {/* Content skeleton */}
      <div className="space-y-2 mb-3">
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>

      {/* Image skeleton */}
      <div className="w-full h-48 bg-gray-200 rounded-lg mb-3"></div>

      {/* Actions skeleton */}
      <div className="flex items-center justify-between">
        <div className="flex space-x-4">
          <div className="h-8 bg-gray-200 rounded w-16"></div>
          <div className="h-8 bg-gray-200 rounded w-16"></div>
          <div className="h-8 bg-gray-200 rounded w-16"></div>
        </div>
        <div className="h-8 bg-gray-200 rounded w-12"></div>
      </div>
    </div>
  );
}
